import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import Modal from '../../../../components/v2/Modal';
import Button from '../../../../components/Button';
import {
  TransitionList,
  TransitionRow,
  TransitionState,
  PoolLabel,
  TransitionIcon,
} from './styles';

import texts from './texts';

const MoveToPoolDialog = ({
  transitions,
  onCancel,
  onConfirm,
  isSaving,
}) => {
  const title = transitions.length === 1
    ? format(texts.title, { coach: transitions[0].name })
    : format(texts.titleMultiple, { count: transitions.length });

  /*
    Cancelling only drops the pending transitions, so once the write is in flight there is nothing
    left to abort — dismissing here would leave the user believing they stopped a bulk pool move that
    then reports success. Every dismissal path (Cancel, the close icon, the backdrop and Escape) ends
    up in onClose with no argument to discriminate on, so they are all held shut together.
  */
  const dismiss = isSaving ? () => {} : onCancel;

  return (
    <Modal
      open
      onClose={dismiss}
      title={title}
      description={texts.description}
      actionButtons={(
        <>
          <Button
            full={false}
            onClick={onConfirm}
            disabled={isSaving}
          >
            {texts.confirm}
          </Button>
          <Button
            full={false}
            secondary
            onClick={dismiss}
            disabled={isSaving}
          >
            {texts.cancel}
          </Button>
        </>
      )}
    >
      <TransitionList>
        {transitions.map(({ id, name, currentAcNames }) => (
          <TransitionRow key={id}>
            <div>{name}</div>
            <TransitionState>
              {currentAcNames.length
                ? format(currentAcNames.length === 1 ? texts.currentAc : texts.currentAcs, {
                  acNames: currentAcNames.join(', '),
                })
                : texts.unassigned}
              <TransitionIcon />
              <PoolLabel>{texts.pool}</PoolLabel>
            </TransitionState>
          </TransitionRow>
        ))}
      </TransitionList>
    </Modal>
  );
};

MoveToPoolDialog.propTypes = {
  transitions: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
};

export default MoveToPoolDialog;
